<script setup lang="ts">
import {useRoute} from "vue-router";
import {computed} from "vue";
import ConsumerProductTrackingView from "@/drug-interaction/views/ConsumerProductTrackingView.vue";

const route = useRoute();

const consumerKey = computed(() => route.query.consumerKey as string | undefined);
</script>

<template>
  <ConsumerProductTrackingView v-if="consumerKey" :consumer-key="consumerKey" />
  <div v-else>
    <p class="text-center text-gray-500">
      Une erreur est survenue
    </p>
  </div>
</template>

<style scoped>

</style>
